/**
 * Device-local state (spec I-7): which dashboard this browser shows, "my energy now", kiosk flag,
 * `for:` default. Stored in localStorage, never synced.
 */
import { create } from "zustand";

const KEYS = {
  dashboard: "drang.device.dashboard",
  energy: "drang.device.energy",
  for: "drang.device.for",
};

function read(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}
function write(key: string, value: string | null): void {
  try {
    if (value === null) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  } catch {
    /* no storage */
  }
}

interface DeviceState {
  dashboard: string | null;
  /** 1–5 or null = no filter */
  energy: number | null;
  forWhom: "me" | "anyone" | string;
  setDashboard(slug: string | null): void;
  setEnergy(e: number | null): void;
  setForWhom(v: string): void;
}

export const useDevice = create<DeviceState>((set) => ({
  dashboard: read(KEYS.dashboard),
  energy: read(KEYS.energy) ? Number(read(KEYS.energy)) : null,
  forWhom: read(KEYS.for) ?? "me",
  setDashboard(slug) {
    write(KEYS.dashboard, slug);
    set({ dashboard: slug });
  },
  setEnergy(e) {
    write(KEYS.energy, e === null ? null : String(e));
    set({ energy: e });
  },
  setForWhom(v) {
    write(KEYS.for, v);
    set({ forWhom: v });
  },
}));
